
import  akash from '../assets/png/akash2.jpg';

export const headerData = {
  name: "Akash P",
  title: "MERN Full Stack Developer",
  desciption:
    "Hi, I'm Akash, a driven and creative MERN Full Stack Developer with a passion for building engaging and user-friendly web applications. My journey as a developer is rooted in a deep fascination for technology and a desire to use it to solve problems and create positive impact. I believe that the right technology, coupled with a thoughtful approach, can empower individuals and businesses in meaningful ways.",
  image: akash,
  resumePdf:
    "https://drive.google.com/file/d/1F_RjDL54F_hASvWgOLVGS2j22B5d4hmF/view",
};
